export const signalLevelFieldValidator = (sections, val, action) => {
    let errors = false;
    let errorMessage = "";

    Object.keys(sections).forEach(section => {
        sections[section].values.forEach((value) => {
            if (value.type === 'number' && ('tap' + value.value === action || 'groundBlock' + value.value === action)) {
                if (!(/^-?[\d]*(\.[\d]+)?$/g).test(val)) {
                    errorMessage = "Value must be in range: [-99.9, 99.9]";
                    errors = true;
                } else {
                    errorMessage = !(parseFloat(val) >= -99.9 && parseFloat(val) <= 99.9) ?
                        "Value must be in range: [-99.9, 99.9]" : null;
                    errors = !(parseFloat(val) >= -99.9 && parseFloat(val) <= 99.9);
                    if (val.split(".").length > 1) {
                        if (val.split(".")[1].length > 1) {
                            errors = true;
                            errorMessage = "Only one decimal is allowed.";
                        }
                    }
                }
            }
        });
    });

    return {
        sections: sections,
        errors: errors,
        errorMessage: errorMessage
    };

};

export const pmTicketSignalLevelFieldValidator = (configs, val, id) => {
    let errors = false;
    let errorMessage = "";

    configs.fields.forEach(field => {
        if (field.id === id) {
            if (!(/^-?[\d]*(\.[\d]+)?$/g).test(val)) {
                errorMessage = "Value must be in range: [-99.9, 99.9]";
                errors = true;
            } else {
                errorMessage = !(parseFloat(val) >= -99.9 && parseFloat(val) <= 99.9) ?
                    "Value must be in range: [-99.9, 99.9]" : null;
                errors = !(parseFloat(val) >= -99.9 && parseFloat(val) <= 99.9);
                if (val.split(".").length > 1) {
                    if (val.split(".")[1].length > 1) {
                        errors = true;
                        errorMessage = "Only one decimal is allowed.";
                    }
                }
            }
        }
    });
    return {
        configs: configs,
        errors: errors,
        errorMessage: errorMessage
    };
};

export const gponSerialNumberFieldValidator = (serialNumber) => {
    if (!serialNumber) {
        return false;
    }
    return /^[a-zA-Z0-9]+$/.test(serialNumber) && serialNumber.length > 0 && serialNumber.length <= 15;
}


// WEBPACK FOOTER //
// ./src/utils/signalLevelFieldValidator.js